@if (builderService.bannerContent()) {
  <builder-content
    class="banner"
    [model]="BANNER_MODEL"
    [content]="builderService.bannerContent()"
    [apiKey]="apiKey"
    [customComponents]="customComponents"
  />
}
<header class="app-header"
        [ngClass]="{ 'navbar-scrolled': isScrolled, 'with-content': builderService.bannerContent() }">
  <app-header-navbar
    (sideNavToggle)="openSidenav()"
    class="app-header-navbar"></app-header-navbar>
  <div class="header-account-area">
    @if (accountService.user().isAuthenticated) {
      <app-button
        size="medium"
        (click)="openWhatsapp()"
        svgIcon="whatsapp"
        text="{{ 'button.msg-whats' | translate }}"></app-button>
      <div class="line-separator"></div>
    }
    @if (!accountService.user().isAuthenticated) {
      <div class="account-navigation">
        <app-button
          (click)="login()"
          data-testid="button-login"
          type="tertiary"
          [text]="'header.login' | translate">
        </app-button>
        <app-button
          routerLink="/register"
          data-testid="button-signup"
          type="secondary"
          [text]="'header.sign-up' | translate">
        </app-button>
      </div>
    } @else {
      <div class="account-navigation">
        <app-button
          #triggerPorfile="matMenuTrigger"
          (menuClosed)="closePopin()"
          (mouseover)="openPopin()"
          [matMenuTriggerFor]="profile"
          data-testid="btn-user"
          type="secondary"
          icon="person"></app-button>
        <app-button
          *appFeatureToggling="'requests-v1'"
          #triggerCart="matMenuTrigger"
          (menuClosed)="closeCartPopin()"
          (mouseover)="openCartPopin()"
          [matMenuTriggerFor]="cart"
          type="secondary"
          icon="shopping_basket"
          [notification]="cartService.cart()?.lineItems?.length ?? 0"></app-button>
        <app-button
          *appFeatureToggling="'requests-v2'"
          #triggerCartV2="matMenuTrigger"
          (menuClosed)="closeCartV2Popin()"
          (mouseover)="openCartV2Popin()"
          [matMenuTriggerFor]="cartV2"
          type="secondary"
          icon="shopping_basket"
          [notification]="cartV2Service.cart()?.lineItems?.length ?? 0"></app-button>
      </div>
    }
    @if (translateFileLoaded) {
      <div class="laguague-selection form-input form-locale">
        <mat-select
          *appFeatureToggling="'allLocalAvailable'"
          panelClass="language-selection-panel"
          [hideSingleSelectionIndicator]="true"
          [formControl]="preferredLanguage"
          [multiple]="false"
          [(value)]="selectedLocal">
          @for (locale of locales; track locale) {
            <mat-option [value]="locale">
              {{ 'locales.' + locale | translate }}
            </mat-option>
          }
        </mat-select>
      </div>
    }
  </div>
</header>
<mat-menu #profile class="account-popin" xPosition="before">
  <div
    (click)="$event.stopPropagation()"
    (mouseleave)="closePopin()"
    class="account-popin-wrapper">
    <app-popin [menuId]="'profile'"></app-popin>
  </div>
</mat-menu>
<mat-menu #cart class="account-popin" xPosition="before">
  <div
    (click)="$event.stopPropagation()"
    (mouseleave)="closeCartPopin()"
    class="account-popin-wrapper account-popin-wrapper-cart">
    <app-popin [menuId]="'cart'"></app-popin>
  </div>
</mat-menu>
<mat-menu #cartV2 class="account-popin" xPosition="before">
  <div
    (click)="$event.stopPropagation()"
    (mouseleave)="closeCartV2Popin()"
    class="account-popin-wrapper account-popin-wrapper-cart">
    <app-popin [menuId]="'cartV2'"></app-popin>
  </div>
</mat-menu>